import { Component, OnDestroy, OnInit } from '@angular/core';
import { schemeData, userData, proposalData } from '../dummayData';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-system',
  standalone: false,
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss']
})
export class SystemComponent implements OnInit, OnDestroy {
  title = 'System Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  systemForm: FormGroup;
  system: any[]=[]
  cols: any[] = [
    { field: 'name', header: 'System Name', filterType: 'text', width: '200px' },
    { field: 'code', header: 'Code', filterType: 'text', width: '300px' },
    { field: 'status', header: 'Status', filterType: 'text', width: '150px' },
  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false
  private subscriptions = new Subscription();

  // Reusable Dialog Configurations
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;
  selectedSystemData: any = {};
  viewMode = false;

  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.systemForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
      status: [true],
      // section: ['', Validators.required]
    });

    // Initialize dialog configurations
    this.initializeDialogConfigs();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private initializeDialogConfigs(): void {
    // Add Dialog Configuration
    this.addDialogConfig = {
      title: 'Add New System',
      width: '80vw',
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog',
      formLayout: 'single-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'text',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Description must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Code',
          type: 'text',
          placeholder: 'Enter Code',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        }
      ]
    };

    // Update/View Dialog Configuration
    this.updateDialogConfig = {
      title: 'Update System',
      width: '80vw',
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog',
      formLayout: 'two-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Description must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Code',
          type: 'text',
          placeholder: 'Enter Code',
          maxLength: 50,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'status',
          label: 'Active',
          type: 'checkbox'
        }
      ]
    };
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/system-master/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const sub = this.api.getAPI(url).subscribe((res: any) => {
      const resp = res.data?.results || res.data || res.results || [];

      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive'
      }));

      this.totalRecords = res.count || 0
    });

    this.subscriptions.add(sub);
  }


  addSystem() {
    this.selectedSystemData = {};
    this.showDialog = true;
    this.getProposal();
  }
  // New methods for reusable dialog
  onSubmitAdd(formData: any): void {
    const payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      status: 1
    };

    const sub = this.api.postAPI('/master/system-master/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'System added successfully'
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res.name || 'Failed to add system'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onSubmitUpdate(formData: any): void {
    const payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      status: formData.status ? 1 : 2
    };

    const sub = this.api.putAPI(`/master/system-master/${this.selectedsystem.id}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'System updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res.detail || 'Failed to update system'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelDialog(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedSystemData = {};
    this.viewMode = false;
    this.selectedsystem = null;
  }

  onCloseDialog(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedSystemData = {};
    this.viewMode = false;
    this.selectedsystem = null;
  }

  // Keep original method for backward compatibility (commented out)
  /*
  onSubmitadd() {
    if (this.systemForm.valid) {
      let payload = {
        name: this.systemForm.get('name')?.value,
        code: this.systemForm.get('code')?.value,
        description: this.systemForm.get('description')?.value,
        section: this.systemForm.get('section')?.value,
        status: 1
      }
      const sub = this.api.postAPI('/master/system-master/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'System added successfully'
          });
          this.showDialog = false;
          this.systemForm.reset();
          this.getSystem();
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'failed',
            detail: res.name
          });
          this.systemForm.reset();
        }
      });
      this.subscriptions.add(sub);

    }
  }
  */
  viewSystem(equipment: any) {
    this.viewMode = true;
    this.updateDialogConfig.title = 'View System';
    
    if (equipment && equipment.id) {
      this.selectedsystem = equipment;
      // Set the data first, then open the dialog
      this.selectedSystemData = {
        name: equipment.name || '',
        code: equipment.code || '',
        description: equipment.description || '',
        status: equipment.status === 'Active' ? true : false
      };
      console.log('View System - Selected Data:', this.selectedSystemData);
      // Use setTimeout to ensure data is set before dialog opens
      setTimeout(() => {
        this.isUpdatedialog = true;
      }, 0);
    }
  }

  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.updateDialogConfig.title = 'Update System';
    
    if (equipment && equipment.id) {
      this.selectedsystem = equipment;
      // Set the data first, then open the dialog
      this.selectedSystemData = {
        name: equipment.name || '',
        code: equipment.code || '',
        description: equipment.description || '',
        status: equipment.status === 'Active' ? true : false
      };
      console.log('Update System - Selected Data:', this.selectedSystemData);
      // Use setTimeout to ensure data is set before dialog opens
      setTimeout(() => {
        this.isUpdatedialog = true;
      }, 0);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No valid system data provided for editing.',
      });
    }
  }
  // Original onSubmitEq method - commented out for reusable dialog integration
  /*
  onSubmitEq() {
    let sectionId = this.selectedsystem.id
    let payload = {
      name: this.systemForm.get('name')?.value,
      section: this.systemForm.get('section')?.value,
      code: this.systemForm.get('code')?.value,
      description: this.systemForm.get('description')?.value,
      status: this.systemForm.get('status')?.value ? 1 : 2
    }
    const sub = this.api.putAPI(`/master/system-master/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'System updated successfully'
        });
        this.isUpdatedialog = false;
        this.systemForm.reset();
        this.getSystem()
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.detail
        });
        this.systemForm.reset();
      }
    });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false;
  }
  */

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/system-master/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'System Deleted Successfully',
        });
        this.showDeleteDialog = false;
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the system. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);
  }

  getProposal() {
    const sub = this.api.getAPI('/master/section-master/').subscribe((res: any) => {
      let resp = res.data
      this.systemSection = resp.map((section: any) => ({
        label: section.name,
        value: section.id
      }));

    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/system', 'Edit') ||
      this.permissionService.hasPrivilege('/master/system', 'Delete')||
      this.permissionService.hasPrivilege('/master/system', 'View');
  }

}